import { createSelector } from '@reduxjs/toolkit'

interface AuthLoginState {
  auth?: {
    error?: {
      login?: string[]
    }
    login?: LoginState
  }
}

interface LoginState {
  isFetching: boolean
  returnUrl: string
  [key: string]: unknown
}

interface LoginSelectorState {
  errors: string[]
  login: LoginState
}

const defaultLoginState: LoginState = {
  isFetching: false,
  returnUrl: '',
}

const selectErrors = (state: Record<string, unknown>) => (state as AuthLoginState).auth?.error?.login
const selectLogin = (state: Record<string, unknown>) => (state as AuthLoginState).auth?.login

export default createSelector(selectErrors, selectLogin, (errors, login): LoginSelectorState => {
  return {
    errors: Array.isArray(errors) ? errors : [],
    login: login ?? defaultLoginState,
  }
})
